import type { IndicatorStatus } from '@openx/components-core/lib/StatusIndicator/StatusIndicator.tsx';
import { getOaDealStatus, oaDealStatus } from '@openx/types/deal.ts';
import type { I18nTranslate } from '@openx/types/translations.ts';

export function mapStatus(
  t: I18nTranslate,
  status?: string
): {
  label: string;
  status: IndicatorStatus;
} | null {
  const Status = getOaDealStatus(t);

  switch (status) {
    case oaDealStatus.PAUSED:
      return {
        label: Status.Paused,
        status: 'paused',
      };
    case oaDealStatus.PUBLISHING:
    case oaDealStatus.READY_FOR_ACTIVATION:
      return {
        label: Status.Publishing,
        status: 'publishing',
      };
    case oaDealStatus.ACTIVE:
      return {
        label: Status.Active,
        status: 'active',
      };
    case oaDealStatus.EXPIRED:
      return {
        label: Status.Expired,
        status: 'expired',
      };
    case oaDealStatus.ERROR:
      return {
        label: Status.Error,
        status: 'error',
      };
    default:
      return null;
  }
}
